import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateDoctoralSchoolFee = () => (
  <Create
    title="Създаване на такса за докторантско училище"
    actions={<BackButtonToolbar />}
  >
    <SimpleForm>
      <SaveForm />
    </SimpleForm>
  </Create>
);

export default CreateDoctoralSchoolFee;
